module.exports = __webpack_public_path__ + "img/vertical_4_3_5010.fc3b837c.png";